import { EQ, GE, GT, LE, LT } from 'shared/api/query/constants';
import { isNotANumber } from 'shared/lib/number';

const isInRange = (value, range) => {
  if (isNotANumber(value)) {
    return false;
  }

  const filters = [];
  if (range.min !== undefined && range.min !== null) {
    let funcName = range.minType;
    if (funcName === undefined || funcName === '') {
      funcName = GE;
    }
    if (funcName === GT) {
      filters.push(value > range.min);
    }
    if (funcName === GE) {
      filters.push(value >= range.min);
    }
    if (funcName === EQ) {
      filters.push(value === range.min);
    }
  }

  if (range.max !== undefined && range.max !== null) {
    let funcName = range.maxType;
    if (funcName === undefined || funcName === '') {
      funcName = LE;
    }
    if (funcName === LT) {
      filters.push(value < range.max);
    }
    if (funcName === LE) {
      filters.push(value <= range.max);
    }
    if (funcName === EQ) {
      filters.push(value === range.max);
    }
  }
  if (filters.length === 0) {
    return false;
  }
  return filters.every((e) => e === true);
};

export const numberFn = ({ propertyValues, scope }) => {
  const neededValue = scope.numberRange;

  const value = propertyValues.find((pv) => pv.property.uid === scope.property.uid)?.number;
  if (value === undefined) {
    return false;
  }

  if (scope.isEmpty) {
    return value === null;
  }

  return isInRange(value, neededValue);
};

export const directNumberFn = ({ entity, scope }) => {
  const neededValue = scope.numberRange;

  const value = entity[scope.directProperty.edgeName];
  if (value === undefined) {
    return false;
  }
  if (scope.isEmpty) {
    return value === null;
  }

  return isInRange(value, neededValue);
};
